import { changeDirection } from 'shared/functions';

export const reorderColumn = (changedColumn, columns) =>
  columns.map(({ name, label, options }) => ({
    name,
    label,
    options: {
      ...options,
      sortDirection: 'none',
      ...(name === changedColumn && {
        sortDirection: changeDirection(options?.sortDirection),
      }),
    },
  }));
